import InsurancePageTemplate from "@/components/InsurancePageTemplate";

export const config = {
  providerName: "Blue Cross and Blue Shield of Texas",
  shortName: "BCBS Texas",
  slug: "bcbstx-insurance",
  seoTitle:
    "Blue Cross and Blue Shield of Texas TMS & SPRAVATO® Coverage | Neuro Wellness TMS",
  seoDescription:
    "Learn how Blue Cross and Blue Shield of Texas policies cover TMS Therapy, SPRAVATO® esketamine, and advanced depression care at Neuro Wellness TMS in Coral Springs, FL.",
  seoKeywords:
    "BCBS Texas TMS coverage, Blue Cross Blue Shield Texas SPRAVATO authorization, BCBSTX mental health benefits Coral Springs FL, BCBS Texas depression treatment Florida",
};

export const BcbstxInsurance = () => <InsurancePageTemplate config={config} />;
export default BcbstxInsurance;
